import { Injectable } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {httpOptionsImage} from '../../configurations/configuration';


// =============================================================================
// v2 SCHEMA — dynamic layouts with multiview-link cells
// =============================================================================

export interface StreamDef {
  name: string;
  url: string;
  audioUrl?: string;       // legacy / inline URL (backward compat)
  audioTrackId?: string;   // preferred: reference to AssetData.audioTracks[].id
}

export interface AudioTrack {
  id: string;
  name: string;
  url: string;
}

export type LayoutPreset = 'grid9' | 'grid4' | 'grid2' | 'gridH' | 'custom';

export interface CameraCell {
  type: 'camera';
  camIndex: number;
  width: string;
  height: string;
  x: string;
  y: string;
}

export interface AdCell {
  type: 'ad';
  adProvider: 'image' | 'adsense' | 'gam';
  width: string;
  height: string;
  x: string;
  y: string;
  imageUrl?: string;
  redirectUrl?: string;
  alt?: string;
  adClient?: string;
  adSlot?: string;
  adUnitPath?: string;
  adSizes?: number[][];
  adDivId?: string;
}

export interface MultiviewLinkCell {
  type: 'multiviewLink';
  targetLayoutId: string;
  width: string;
  height: string;
  x: string;
  y: string;
  displayName?: string;
}

export type Cell = CameraCell | AdCell | MultiviewLinkCell;

export interface Layout {
  id: string;
  name: string;
  masterUrl: string;
  preset: LayoutPreset;
  rows: number;
  cols: number;
  enabled: boolean;
  audioUrl?: string;       // legacy / inline URL (backward compat)
  audioTrackId?: string;   // preferred: reference to AssetData.audioTracks[].id
  cells: Cell[];
}

export interface AssetData {
  id: string;
  schemaVersion?: number;
  // legacy v1 fields kept optional so older imports still type-check
  videoUrl?: string;
  video_H_Url?: string;
  video_dual_Url?: string;
  video_quad_Url?: string;
  // global
  audiourl: string;
  programcutUrl: string;
  Program: string;
  streamUrls: StreamDef[];
  contentType?: 'vod' | 'live' | 'encorelive';
  signalChannel?: string;
  chatEnabled?: boolean;
  chatChannel?: string;
  chatEnablePrivate?: boolean;   // v2: enable per-user private rooms in addition to the public channel
  chatRoomPrefix?: string;       // v2: optional override; when blank, prefix derives from chatChannel
  multiViewEnabled?: boolean;
  // v2 ads (Player C / Google IMA). Emitted as adConfig in the backend JSON.
  adEnabled?: boolean;
  adTagUrl?: string;                                  // VAST (single) or VMAP (scheduled) tag URL
  adTriggerMode?: 'preroll' | 'vmap' | 'manual';      // when the SDK fires the break
  // v2
  layouts?: Layout[];
  defaultLayoutId?: string;
  audioTracks?: AudioTrack[];   // named, reusable audio track library
}

// =============================================================================
// v1 legacy types (kept exported so other files can still compile during migration)
// =============================================================================

export interface LayoutConfig { layout: any[][]; }
export interface LayoutConfigsMap {
  grid9: LayoutConfig;
  grid4: LayoutConfig;
  grid2: LayoutConfig;
  gridH: LayoutConfig;
}
export type CellConfig = Cell; // alias for back-compat with imports

// =============================================================================
// Validation
// =============================================================================

export type IssueSeverity = 'error' | 'warning';
export type IssueCategory = 'syntax' | 'schema' | 'semantic';

export interface ValidationIssue {
  path: string;        // e.g. "layouts[2].cells[3].camIndex"
  message: string;
  severity: IssueSeverity;
  category: IssueCategory;
  layoutId?: string;   // for grouping
}


@Injectable({
  providedIn: 'root',

})
export class AssetService {

    private ASSET_KEY = 'assetData';
    private LAYOUT_KEY = 'layoutConfigs';
    API_ENDPOINT = '/asset/createstreamconfig';

  constructor(private http: HttpClient) { }

    updateAsset(postObj:any) : Observable<any> {

        console.log(">>updateAssetUrl>>",environment.updateAssetUrl);
        postObj.langId = localStorage.getItem('languageId');
        if(postObj.langId== null){
            postObj.langId = '1';

        }

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateAssetUrl, postObj,httpOptions);
    }

    insertAsset(postObj:any) : Observable<any> {

        postObj.langId = localStorage.getItem('languageId');

        if(postObj.langId== null){
            postObj.langId = '1';

        }
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertAssetUrl, postObj,httpOptions);
    }

    getAsset( id: any, langId:any) : Observable<any> {

        langId = localStorage.getItem('languageId');

        if(langId == null){
            langId = '1';
        }

        if(id){
            return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getAssetUrl+"/" + id +"/" + langId);
        }

    }


    getRefreshUplynk( ) : Observable<any> {

            return this.http.get(environment.apiURL + environment.adminApiUrl + environment.refreshUplynkUrl)
    }

    getAllAsset(filterObj,start,limit){

        filterObj.languageId = localStorage.getItem('languageId');
        if(filterObj.languageId == null){
            filterObj.languageId = '1';
        }


        let urlGetAllAsset = environment.apiURL + environment.adminApiUrl + environment.getAssetUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllAsset)
    }

    deleteAsset(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteAssetUrl, postObj,httpOptions);
    }
    deleteMultiple(postObj:any) : Observable<any> {
      return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteMultiple, postObj,httpOptions);
  }

    insertAssetGroup(postObj) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertAssetGroupUrl, postObj,httpOptions);
    }

    updateAssetGroup(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateAssetGroupUrl, postObj,httpOptions);
    }

    getAssetGroup( id: any, langId:any) : Observable<any> {

        langId = localStorage.getItem('languageId');


        if(id){
            return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getAssetGroupUrl+"/" + id +"/" + langId);
        }

    }

    // -----------------------------------------------------------------------
    // Legacy v1 localStorage helpers (kept for back-compat; new code uses v2)
    // -----------------------------------------------------------------------

    getAssetData(id): AssetData {
        const raw = localStorage.getItem(this.ASSET_KEY);
        if (raw) return JSON.parse(raw);
        return this.defaultAssetV2(id);
    }

    setAssetData(data: AssetData) {
        localStorage.setItem(this.ASSET_KEY, JSON.stringify(data));
    }

    getLayouts(): LayoutConfigsMap {
        const raw = localStorage.getItem(this.LAYOUT_KEY);
        if (raw) return JSON.parse(raw);
        return {
          grid9: { layout: [] },
          grid4: { layout: [] },
          grid2: { layout: [] },
          gridH: { layout: [] }
        };
    }

    setLayouts(cfg: any) {
        localStorage.setItem(this.LAYOUT_KEY, JSON.stringify(cfg));
    }

    sendConfig(config: any): Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + this.API_ENDPOINT, config);
    }

    getConfig(id: any): Observable<any> {
        console.log(environment.apiURL + environment.adminApiUrl + "/asset/streamconfig/"+id)
        return this.http.get(environment.apiURL + environment.adminApiUrl + "/asset/streamconfig/"+id);
    }

    defaultAssetData(id): AssetData {
        return this.defaultAssetV2(id);
    }

    emptyLayouts(): LayoutConfigsMap {
        return {
          grid9: { layout: [] },
          grid4: { layout: [] },
          grid2: { layout: [] },
          gridH: { layout: [] }
        };
    }

    clearLayoutAndAsset(): void {
        localStorage.removeItem(this.LAYOUT_KEY);
        localStorage.removeItem(this.ASSET_KEY);
    }

    clearLayout(): void {
        localStorage.removeItem(this.LAYOUT_KEY);
    }

    clearAsset(): void {
        localStorage.removeItem(this.ASSET_KEY);
    }

    // -----------------------------------------------------------------------
    // v2 API
    // -----------------------------------------------------------------------

    /**
     * Reads a raw asset payload (v1 or v2) and returns a normalised v2 AssetData.
     * v1 → builds layouts[] from the 4 fixed master URLs + layoutConfigs.
     * v2 → passes through, normalising any partial fields.
     */
    adaptV1ToV2(raw: any, fallbackId: string = ''): AssetData {
      if (!raw) return this.defaultAssetV2(fallbackId);

      // Already v2
      if (raw.schemaVersion === 2 && Array.isArray(raw.layouts)) {
        const layouts = raw.layouts.map((l: any) => this.normalizeLayout(l));
        return {
          id: raw.id || fallbackId,
          schemaVersion: 2,
          audiourl: raw.audiourl || '',
          programcutUrl: raw.programcutUrl || '',
          Program: raw.Program || '',
          streamUrls: Array.isArray(raw.streamUrls) ? raw.streamUrls : [],
          contentType: raw.contentType,
          signalChannel: raw.signalChannel,
          chatEnabled: raw.chatEnabled || (raw.chatConfig && raw.chatConfig.showChat) || false,
          chatChannel: raw.chatChannel || (raw.chatConfig && raw.chatConfig.channel) || '',
          chatEnablePrivate: raw.chatEnablePrivate || (raw.chatConfig && raw.chatConfig.enablePrivateRooms) || false,
          chatRoomPrefix: raw.chatRoomPrefix || (raw.chatConfig && raw.chatConfig.roomPrefix) || '',
          adEnabled: raw.adEnabled || (raw.adConfig && raw.adConfig.enabled) || false,
          adTagUrl: raw.adTagUrl || (raw.adConfig && raw.adConfig.adTagUrl) || '',
          adTriggerMode: raw.adTriggerMode || (raw.adConfig && raw.adConfig.triggerMode) || 'preroll',
          multiViewEnabled: raw.multiViewEnabled,
          layouts,
          defaultLayoutId: raw.defaultLayoutId,
          audioTracks: Array.isArray(raw.audioTracks) ? raw.audioTracks : []
        };
      }

      // v1 → v2 conversion
      const v1ToV2Map: Array<{ id: string; name: string; urlField: string; preset: LayoutPreset; rows: number; cols: number }> = [
        { id: 'grid9', name: 'Grid',   urlField: 'videoUrl',       preset: 'grid9', rows: 3, cols: 3 },
        { id: 'grid4', name: 'Quad',   urlField: 'video_quad_Url', preset: 'grid4', rows: 2, cols: 2 },
        { id: 'grid2', name: 'Dual',   urlField: 'video_dual_Url', preset: 'grid2', rows: 2, cols: 2 },
        { id: 'gridH', name: 'H View', urlField: 'video_H_Url',    preset: 'gridH', rows: 4, cols: 3 }
      ];

      const layouts: Layout[] = v1ToV2Map.map(m => ({
        id: m.id,
        name: m.name,
        masterUrl: raw[m.urlField] || '',
        preset: m.preset,
        rows: m.rows,
        cols: m.cols,
        enabled: !!raw[m.urlField],
        audioUrl: undefined,
        cells: this.flattenV1Layout(raw.layoutConfigs && raw.layoutConfigs[m.id] && raw.layoutConfigs[m.id].layout)
      }));

      return {
        id: raw.id || fallbackId,
        schemaVersion: 2,
        audiourl: raw.audiourl || '',
        programcutUrl: raw.programcutUrl || '',
        Program: raw.Program || '',
        streamUrls: Array.isArray(raw.streamUrls) ? raw.streamUrls : [],
        contentType: raw.contentType,
        signalChannel: raw.signalChannel,
        chatEnabled: raw.chatEnabled || (raw.chatConfig && raw.chatConfig.showChat) || false,
        chatChannel: raw.chatChannel || (raw.chatConfig && raw.chatConfig.channel) || '',
        chatEnablePrivate: raw.chatEnablePrivate || (raw.chatConfig && raw.chatConfig.enablePrivateRooms) || false,
        chatRoomPrefix: raw.chatRoomPrefix || (raw.chatConfig && raw.chatConfig.roomPrefix) || '',
        adEnabled: raw.adEnabled || (raw.adConfig && raw.adConfig.enabled) || false,
        adTagUrl: raw.adTagUrl || (raw.adConfig && raw.adConfig.adTagUrl) || '',
        adTriggerMode: raw.adTriggerMode || (raw.adConfig && raw.adConfig.triggerMode) || 'preroll',
        multiViewEnabled: raw.multiViewEnabled,
        layouts,
        defaultLayoutId: raw.defaultLayoutId,
        audioTracks: []
      };
    }

    private normalizeLayout(l: any): Layout {
      return {
        id: l.id || this.makeId(),
        name: l.name || 'Untitled',
        masterUrl: l.masterUrl || '',
        preset: l.preset || 'custom',
        rows: typeof l.rows === 'number' ? l.rows : 2,
        cols: typeof l.cols === 'number' ? l.cols : 2,
        enabled: l.enabled !== false,
        audioUrl: l.audioUrl,
        audioTrackId: l.audioTrackId,
        cells: Array.isArray(l.cells) ? (l.cells.map((c: any) => this.normalizeCell(c)).filter((c: Cell | null) => c !== null) as Cell[]) : []
      };
    }

    private normalizeCell(c: any): Cell | null {
      if (!c) return null;
      // v1 cells didn't have explicit `type` — infer it
      const type = c.type || (c.camIndex !== undefined ? 'camera' : null);
      if (type === 'camera') {
        return {
          type: 'camera',
          camIndex: typeof c.camIndex === 'number' ? c.camIndex : 0,
          x: c.x || '0%',
          y: c.y || '0%',
          width: c.width || '50%',
          height: c.height || '50%'
        };
      }
      if (type === 'ad') {
        return {
          type: 'ad',
          adProvider: c.adProvider || 'image',
          x: c.x || '0%',
          y: c.y || '0%',
          width: c.width || '100%',
          height: c.height || '20%',
          imageUrl: c.imageUrl,
          redirectUrl: c.redirectUrl,
          alt: c.alt,
          adClient: c.adClient,
          adSlot: c.adSlot,
          adUnitPath: c.adUnitPath,
          adSizes: c.adSizes,
          adDivId: c.adDivId
        };
      }
      if (type === 'multiviewLink') {
        return {
          type: 'multiviewLink',
          targetLayoutId: c.targetLayoutId || '',
          x: c.x || '0%',
          y: c.y || '0%',
          width: c.width || '50%',
          height: c.height || '50%',
          displayName: c.displayName
        };
      }
      return null;
    }

    /** Flattens v1 column-major layout into v2 flat cells with explicit type. */
    flattenV1Layout(legacyLayout: any): Cell[] {
      if (!Array.isArray(legacyLayout)) return [];
      const cells: Cell[] = [];
      for (const col of legacyLayout) {
        if (!Array.isArray(col)) continue;
        for (const c of col) {
          const normalized = this.normalizeCell(c);
          if (normalized) cells.push(normalized);
        }
      }
      return cells;
    }

    /** Returns the 4 canonical defaults as v2 Layouts. */
    getDefaultLayoutsV2(): Layout[] {
      return [
        { id: 'grid9', name: 'Grid',   masterUrl: '', preset: 'grid9', rows: 3, cols: 3, enabled: true, cells: this.flattenV1Layout(this.defaultGrid9Layout()) },
        { id: 'grid4', name: 'Quad',   masterUrl: '', preset: 'grid4', rows: 2, cols: 2, enabled: true, cells: this.flattenV1Layout(this.defaultGrid4Layout()) },
        { id: 'grid2', name: 'Dual',   masterUrl: '', preset: 'grid2', rows: 2, cols: 2, enabled: true, cells: this.flattenV1Layout(this.defaultGrid2Layout()) },
        { id: 'gridH', name: 'H View', masterUrl: '', preset: 'gridH', rows: 4, cols: 3, enabled: true, cells: this.flattenV1Layout(this.defaultGridHLayout()) }
      ];
    }

    /** Generates a starter cells[] for a given preset. */
    generateCellsForPreset(preset: LayoutPreset): Cell[] {
      if (preset === 'grid9') return this.flattenV1Layout(this.defaultGrid9Layout());
      if (preset === 'grid4') return this.flattenV1Layout(this.defaultGrid4Layout());
      if (preset === 'grid2') return this.flattenV1Layout(this.defaultGrid2Layout());
      if (preset === 'gridH') return this.flattenV1Layout(this.defaultGridHLayout());
      return []; // custom = empty
    }

    /** Default v2 asset for a fresh asset_id. */
    defaultAssetV2(id: string): AssetData {
      return {
        id,
        schemaVersion: 2,
        audiourl: '',
        programcutUrl: '',
        Program: '',
        streamUrls: Array.from({ length: 9 }, (_, i) => ({ name: `Camera ${i + 1}`, url: '' })),
        contentType: 'vod',
        signalChannel: '',
        chatEnabled: false,
        chatChannel: '',
        chatEnablePrivate: false,
        chatRoomPrefix: '',
        adEnabled: false,
        adTagUrl: '',
        adTriggerMode: 'preroll',
        multiViewEnabled: true,
        layouts: this.getDefaultLayoutsV2(),
        defaultLayoutId: undefined,
        audioTracks: []
      };
    }

    /** Builds the v2 JSON payload to send to backend. */
    generateBackendJSONV2(asset: AssetData): any {
      const chatChannel = asset.chatChannel || '';
      // Prefix defaults to "<channel>-private-room" when not explicitly set,
      // matching the user's "prefix is based on chat room name" rule. An
      // operator can still override via the Private Room Prefix field.
      const derivedPrefix = chatChannel ? `${chatChannel}-private-room` : '';
      const roomPrefix = (asset.chatRoomPrefix && asset.chatRoomPrefix.trim())
        ? asset.chatRoomPrefix.trim()
        : derivedPrefix;

      return {
        schemaVersion: 2,
        audiourl: asset.audiourl || '',
        programcutUrl: asset.programcutUrl || '',
        Program: asset.Program || '',
        streamUrls: asset.streamUrls || [],
        contentType: asset.contentType || 'vod',
        signalChannel: asset.signalChannel || 'volta-control',
        // Flat fields retained for back-compat with older SDK readers.
        chatEnabled: !!asset.chatEnabled,
        chatChannel,
        // v2 chatConfig consumed by the player UI.
        chatConfig: asset.chatEnabled ? {
          channel: chatChannel,
          showChat: true,
          enablePrivateRooms: !!asset.chatEnablePrivate,
          roomPrefix: asset.chatEnablePrivate ? roomPrefix : ''
        } : { showChat: false },
        // v2 adConfig (Player C / IMA) consumed by the SDK. insertion is
        // 'client' (CSAI / VAST-VMAP) for now; 'ssai'/'dai' reserved for later.
        adConfig: asset.adEnabled ? {
          enabled: true,
          insertion: 'client',
          adTagUrl: asset.adTagUrl || '',
          triggerMode: asset.adTriggerMode || 'preroll'
        } : { enabled: false },
        multiViewEnabled: asset.multiViewEnabled !== false,
        layouts: asset.layouts || [],
        defaultLayoutId: asset.defaultLayoutId,
        audioTracks: asset.audioTracks || [],
        // Also emit the legacy fields so any old reader (eg. older SDK) still gets URLs.
        // SDK adapter will prefer `layouts[]` when schemaVersion === 2.
        videoUrl:        this.findLayoutMasterUrl(asset.layouts, 'grid9'),
        video_H_Url:     this.findLayoutMasterUrl(asset.layouts, 'gridH'),
        video_dual_Url:  this.findLayoutMasterUrl(asset.layouts, 'grid2'),
        video_quad_Url:  this.findLayoutMasterUrl(asset.layouts, 'grid4'),
        // Emit legacy column-major layoutConfigs for any old SDK still using v1
        layoutConfigs: this.rebuildLegacyLayoutConfigs(asset.layouts)
      };
    }

    private findLayoutMasterUrl(layouts: Layout[] | undefined, presetId: string): string {
      if (!layouts) return '';
      const layout = layouts.find(l => l.id === presetId || l.preset === presetId);
      return layout ? layout.masterUrl || '' : '';
    }

    /** Rebuilds legacy column-major layoutConfigs from v2 layouts, best-effort. */
    private rebuildLegacyLayoutConfigs(layouts: Layout[] | undefined): any {
      const result: any = {
        grid9: { layout: [] },
        grid4: { layout: [] },
        grid2: { layout: [] },
        gridH: { layout: [] }
      };
      if (!layouts) return result;
      for (const l of layouts) {
        const presetKey = l.preset;
        if (presetKey === 'custom') continue;
        if (!result[presetKey]) continue;
        // Group cells into a single column for legacy readers — exact column positions
        // are not reconstructable from flat cells, so we emit a single flat row that
        // the legacy SDK still consumes via its cell.x/y/width/height fields.
        result[presetKey].layout = [l.cells];
      }
      return result;
    }

    // -----------------------------------------------------------------------
    // v1 default layout literals (used by both v1 path and the v2 adapter)
    // -----------------------------------------------------------------------

    private defaultGrid9Layout(): any[][] {
      return [
        [
          { camIndex: 0, width: '33.33%', height: '33.33%', x: '0%', y: '0%' },
          { camIndex: 1, width: '33.33%', height: '33.33%', x: '0%', y: '33.33%' },
          { camIndex: 2, width: '33.33%', height: '33.33%', x: '0%', y: '66.66%' }
        ],
        [
          { camIndex: 3, width: '33.33%', height: '33.33%', x: '33.33%', y: '0%' },
          { camIndex: 4, width: '33.33%', height: '33.33%', x: '33.33%', y: '33.33%' },
          { camIndex: 5, width: '33.33%', height: '33.33%', x: '33.33%', y: '66.66%' }
        ],
        [
          { camIndex: 6, width: '33.33%', height: '33.33%', x: '66.66%', y: '0%' },
          { camIndex: 7, width: '33.33%', height: '33.33%', x: '66.66%', y: '33.33%' },
          { camIndex: 8, width: '33.33%', height: '33.33%', x: '66.66%', y: '66.66%' }
        ]
      ];
    }

    private defaultGrid4Layout(): any[][] {
      return [
        [
          { camIndex: 0, width: '50%', height: '50%', x: '0%', y: '0%' },
          { camIndex: 3, width: '50%', height: '50%', x: '0%', y: '50%' }
        ],
        [
          { camIndex: 2, width: '50%', height: '50%', x: '50%', y: '0%' },
          { camIndex: 4, width: '50%', height: '50%', x: '50%', y: '50%' }
        ]
      ];
    }

    private defaultGrid2Layout(): any[][] {
      return [
        [
          { camIndex: 0, width: '50%', height: '53.1%', x: '0%', y: '23%' }
        ],
        [
          { camIndex: 3, width: '50%', height: '53.1%', x: '50%', y: '23%' }
        ],
        [],
        []
      ];
    }

    private defaultGridHLayout(): any[][] {
      return [
        [
          { camIndex: 1, width: '25%', height: '25%', x: '0%', y: '0%' },
          { camIndex: 7, width: '25%', height: '25%', x: '0%', y: '25%' },
          { camIndex: 5, width: '25%', height: '25%', x: '0%', y: '50%' },
          { camIndex: 2, width: '25%', height: '25%', x: '0%', y: '75%' }
        ],
        [
          null,
          { camIndex: 2, width: '50%', height: '50%', x: '25%', y: '25%' },
          null
        ],
        [
          { camIndex: 8, width: '25%', height: '25%', x: '75%', y: '0%' },
          { camIndex: 3, width: '25%', height: '25%', x: '75%', y: '25%' },
          { camIndex: 9, width: '25%', height: '25%', x: '75%', y: '50%' },
          { camIndex: 6, width: '25%', height: '25%', x: '75%', y: '75%' }
        ]
      ];
    }

    /** Stable id generator for new layouts/cells. */
    makeId(prefix: string = 'lay'): string {
      const random = Math.random().toString(36).slice(2, 10);
      return `${prefix}_${Date.now().toString(36)}_${random}`;
    }

    // -----------------------------------------------------------------------
    // Validation
    // -----------------------------------------------------------------------

    /** Validates a v2 asset, returns flat list of issues (errors + warnings). */
    validateAsset(asset: AssetData): ValidationIssue[] {
      const out: ValidationIssue[] = [];

      if (!asset) {
        out.push({ path: '', message: 'Asset is null or undefined', severity: 'error', category: 'schema' });
        return out;
      }

      // -- streamUrls --
      if (!Array.isArray(asset.streamUrls)) {
        out.push({ path: 'streamUrls', message: 'streamUrls must be an array', severity: 'error', category: 'schema' });
      } else {
        if (asset.streamUrls.length === 0) {
          out.push({ path: 'streamUrls', message: 'No camera streams configured', severity: 'warning', category: 'semantic' });
        }
        asset.streamUrls.forEach((s: any, i: number) => {
          if (!s || typeof s !== 'object') {
            out.push({ path: `streamUrls[${i}]`, message: 'Stream entry is not an object', severity: 'error', category: 'schema' });
            return;
          }
          if (!s.name || !String(s.name).trim()) {
            out.push({ path: `streamUrls[${i}].name`, message: 'Stream name is required', severity: 'error', category: 'schema' });
          }
          if (!s.url || !String(s.url).trim()) {
            out.push({ path: `streamUrls[${i}].url`, message: `Stream "${s.name || i + 1}" has no URL`, severity: 'warning', category: 'semantic' });
          }
        });
      }

      // -- audioTracks --
      const trackIds = new Set<string>();
      if (Array.isArray(asset.audioTracks)) {
        asset.audioTracks.forEach((t: any, i: number) => {
          if (!t || typeof t !== 'object') {
            out.push({ path: `audioTracks[${i}]`, message: 'Audio track is not an object', severity: 'error', category: 'schema' });
            return;
          }
          if (!t.id || !String(t.id).trim()) {
            out.push({ path: `audioTracks[${i}].id`, message: 'Audio track id is required', severity: 'error', category: 'schema' });
          } else if (trackIds.has(t.id)) {
            out.push({ path: `audioTracks[${i}].id`, message: `Duplicate audio track id "${t.id}"`, severity: 'error', category: 'schema' });
          } else {
            trackIds.add(t.id);
          }
          if (!t.name || !String(t.name).trim()) {
            out.push({ path: `audioTracks[${i}].name`, message: 'Audio track name is required', severity: 'error', category: 'schema' });
          }
          if (!t.url || !String(t.url).trim()) {
            out.push({ path: `audioTracks[${i}].url`, message: `Audio track "${t.name || i + 1}" has no URL`, severity: 'warning', category: 'semantic' });
          }
        });
      }

      // -- stream-level audioTrackId references --
      if (Array.isArray(asset.streamUrls)) {
        asset.streamUrls.forEach((s: any, i: number) => {
          if (s && s.audioTrackId && !trackIds.has(s.audioTrackId)) {
            out.push({
              path: `streamUrls[${i}].audioTrackId`,
              message: `Audio track "${s.audioTrackId}" not found in audioTracks`,
              severity: 'error',
              category: 'semantic'
            });
          }
        });
      }

      // -- layouts --
      if (!Array.isArray(asset.layouts)) {
        out.push({ path: 'layouts', message: 'layouts must be an array', severity: 'error', category: 'schema' });
        return out;
      }
      if (asset.layouts.length === 0) {
        out.push({ path: 'layouts', message: 'No layouts defined', severity: 'warning', category: 'semantic' });
      }

      // duplicate IDs
      const idCounts: { [k: string]: number } = {};
      for (const l of asset.layouts) {
        if (!l || !l.id) continue;
        idCounts[l.id] = (idCounts[l.id] || 0) + 1;
      }
      for (const id in idCounts) {
        if (idCounts[id] > 1) {
          out.push({ path: 'layouts', message: `Duplicate layout ID "${id}" appears ${idCounts[id]} times`, severity: 'error', category: 'schema' });
        }
      }

      // landing
      if (!asset.defaultLayoutId) {
        out.push({ path: 'defaultLayoutId', message: 'No landing layout selected', severity: 'warning', category: 'semantic' });
      } else if (!asset.layouts.find(l => l.id === asset.defaultLayoutId)) {
        out.push({ path: 'defaultLayoutId', message: `Landing layout id "${asset.defaultLayoutId}" not found in layouts`, severity: 'error', category: 'semantic' });
      }

      const validPresets: LayoutPreset[] = ['grid9', 'grid4', 'grid2', 'gridH', 'custom'];
      const dimRe = /^-?\d+(\.\d+)?(%|px)$/;

      asset.layouts.forEach((layout: any, lIdx: number) => {
        const lp = `layouts[${lIdx}]`;
        const lid = layout && layout.id;

        if (!layout || typeof layout !== 'object') {
          out.push({ path: lp, message: 'Layout is not an object', severity: 'error', category: 'schema', layoutId: lid });
          return;
        }
        if (!layout.id || !String(layout.id).trim()) {
          out.push({ path: `${lp}.id`, message: 'Layout id is required', severity: 'error', category: 'schema' });
        }
        if (!layout.name || !String(layout.name).trim()) {
          out.push({ path: `${lp}.name`, message: 'Layout name is required', severity: 'error', category: 'schema', layoutId: lid });
        }
        if (!validPresets.includes(layout.preset)) {
          out.push({ path: `${lp}.preset`, message: `Invalid preset "${layout.preset}"`, severity: 'error', category: 'schema', layoutId: lid });
        }
        if (typeof layout.enabled !== 'boolean') {
          out.push({ path: `${lp}.enabled`, message: 'enabled must be true or false', severity: 'error', category: 'schema', layoutId: lid });
        }
        if (layout.enabled && (!layout.masterUrl || !String(layout.masterUrl).trim())) {
          out.push({ path: `${lp}.masterUrl`, message: `Enabled layout "${layout.name}" has empty master URL`, severity: 'warning', category: 'semantic', layoutId: lid });
        }
        if (layout.audioTrackId && !trackIds.has(layout.audioTrackId)) {
          out.push({
            path: `${lp}.audioTrackId`,
            message: `Audio track "${layout.audioTrackId}" not found in audioTracks`,
            severity: 'error',
            category: 'semantic',
            layoutId: lid
          });
        }

        if (!Array.isArray(layout.cells)) {
          out.push({ path: `${lp}.cells`, message: 'cells must be an array', severity: 'error', category: 'schema', layoutId: lid });
          return;
        }
        if (layout.cells.length === 0) {
          out.push({ path: `${lp}.cells`, message: `Layout "${layout.name}" has no cells`, severity: 'warning', category: 'semantic', layoutId: lid });
        }

        layout.cells.forEach((cell: any, cIdx: number) => {
          const cp = `${lp}.cells[${cIdx}]`;
          if (!cell || typeof cell !== 'object') {
            out.push({ path: cp, message: 'Cell is not an object', severity: 'error', category: 'schema', layoutId: lid });
            return;
          }

          for (const d of ['x', 'y', 'width', 'height']) {
            const v = cell[d];
            if (typeof v !== 'string' || !dimRe.test(v)) {
              out.push({ path: `${cp}.${d}`, message: `Invalid ${d} "${v}" — must be like "50%" or "200px"`, severity: 'error', category: 'schema', layoutId: lid });
            }
          }

          if (cell.type === 'camera') {
            const streamCount = (asset.streamUrls || []).length;
            if (typeof cell.camIndex !== 'number') {
              out.push({ path: `${cp}.camIndex`, message: 'camIndex must be a number', severity: 'error', category: 'schema', layoutId: lid });
            } else if (cell.camIndex < 0 || cell.camIndex >= streamCount) {
              out.push({ path: `${cp}.camIndex`, message: `camIndex ${cell.camIndex} out of range (0..${streamCount - 1})`, severity: 'error', category: 'semantic', layoutId: lid });
            }
          } else if (cell.type === 'ad') {
            const provider = cell.adProvider;
            if (!['image', 'adsense', 'gam'].includes(provider)) {
              out.push({ path: `${cp}.adProvider`, message: `Invalid adProvider "${provider}"`, severity: 'error', category: 'schema', layoutId: lid });
            } else if (provider === 'image') {
              if (!cell.imageUrl) out.push({ path: `${cp}.imageUrl`, message: 'imageUrl required for image ad', severity: 'error', category: 'schema', layoutId: lid });
              if (!cell.redirectUrl) out.push({ path: `${cp}.redirectUrl`, message: 'redirectUrl required for image ad', severity: 'error', category: 'schema', layoutId: lid });
            } else if (provider === 'adsense') {
              if (!cell.adClient) out.push({ path: `${cp}.adClient`, message: 'adClient required for AdSense', severity: 'error', category: 'schema', layoutId: lid });
              if (!cell.adSlot) out.push({ path: `${cp}.adSlot`, message: 'adSlot required for AdSense', severity: 'error', category: 'schema', layoutId: lid });
            } else if (provider === 'gam') {
              if (!cell.adUnitPath) out.push({ path: `${cp}.adUnitPath`, message: 'adUnitPath required for GAM', severity: 'error', category: 'schema', layoutId: lid });
              if (!cell.adDivId) out.push({ path: `${cp}.adDivId`, message: 'adDivId required for GAM', severity: 'error', category: 'schema', layoutId: lid });
            }
          } else if (cell.type === 'multiviewLink') {
            const target = cell.targetLayoutId;
            if (!target) {
              out.push({ path: `${cp}.targetLayoutId`, message: 'targetLayoutId is required for multiviewLink', severity: 'error', category: 'schema', layoutId: lid });
            } else if (target === layout.id) {
              out.push({ path: `${cp}.targetLayoutId`, message: 'A layout cannot link to itself', severity: 'error', category: 'semantic', layoutId: lid });
            } else {
              const tgt = asset.layouts.find(l => l.id === target);
              if (!tgt) {
                out.push({ path: `${cp}.targetLayoutId`, message: `Link target "${target}" not found in layouts`, severity: 'error', category: 'semantic', layoutId: lid });
              } else if (!tgt.enabled) {
                out.push({ path: `${cp}.targetLayoutId`, message: `Link target "${tgt.name}" is disabled`, severity: 'warning', category: 'semantic', layoutId: lid });
              }
            }
          } else {
            out.push({ path: `${cp}.type`, message: `Unknown cell type "${cell.type}"`, severity: 'error', category: 'schema', layoutId: lid });
          }
        });
      });

      // (Reachability via multiview-links is optional — layouts are also reachable
      //  through the SDK's layout dropdown menu, so we don't flag "orphans".)

      return out;
    }

    /** Get a value from an object at a dotted+bracketed path. */
    getValueAtPath(obj: any, path: string): any {
      if (!path) return obj;
      const parts = this.parsePath(path);
      let cur: any = obj;
      for (const p of parts) {
        if (cur == null) return undefined;
        cur = cur[p];
      }
      return cur;
    }

    /** Set a value in an object at a dotted+bracketed path. */
    setValueAtPath(obj: any, path: string, value: any): void {
      if (!path) return;
      const parts = this.parsePath(path);
      let cur: any = obj;
      for (let i = 0; i < parts.length - 1; i++) {
        if (cur[parts[i]] == null) return;
        cur = cur[parts[i]];
      }
      cur[parts[parts.length - 1]] = value;
    }

    private parsePath(path: string): Array<string | number> {
      const parts: Array<string | number> = [];
      const re = /([^.[\]]+)|\[(\d+)\]/g;
      let m: RegExpExecArray | null;
      while ((m = re.exec(path)) !== null) {
        if (m[2] !== undefined) parts.push(parseInt(m[2], 10));
        else parts.push(m[1]);
      }
      return parts;
    }

    // -----------------------------------------------------------------------
    // DEPRECATED — kept only to avoid breaking imports.
    // -----------------------------------------------------------------------

    /** @deprecated use getDefaultLayoutsV2() */
    getdefaultLayouts(): LayoutConfigsMap {
      return {
        grid9: { layout: this.defaultGrid9Layout() },
        grid4: { layout: this.defaultGrid4Layout() },
        grid2: { layout: this.defaultGrid2Layout() },
        gridH: { layout: this.defaultGridHLayout() }
      };
    }

    /** @deprecated use generateBackendJSONV2 */
    generateBackendJSON(layoutConfigs: any, id: string): any {
      const assetData = this.getAssetData(id);
      const finalStreams: StreamDef[] = [];
      const src = assetData.streamUrls || [];
      const chatChannel = assetData.chatChannel || '';
      const derivedPrefix = chatChannel ? `${chatChannel}-private-room` : '';
      const roomPrefix = (assetData.chatRoomPrefix && assetData.chatRoomPrefix.trim())
        ? assetData.chatRoomPrefix.trim()
        : derivedPrefix;
      for (let i = 0; i < 9; i++) {
        if (src[i]) finalStreams.push(src[i]);
        else finalStreams.push({ url: 'https://example.com/camera' + (i + 1) + '.m3u8', name: 'Camera ' + (i + 1) });
      }
      return {
        videoUrl: assetData.videoUrl || '',
        video_H_Url: assetData.video_H_Url || '',
        video_dual_Url: assetData.video_dual_Url || '',
        video_quad_Url: assetData.video_quad_Url || '',
        audiourl: assetData.audiourl || '',
        programcutUrl: assetData.programcutUrl || '',
        streamUrls: finalStreams,
        layoutConfigs: layoutConfigs,
        Program: assetData.Program,
        contentType: assetData.contentType || 'vod',
        signalChannel: assetData.signalChannel || 'volta-control',
        chatEnabled: !!assetData.chatEnabled,
        chatChannel,
        chatEnablePrivate: !!assetData.chatEnablePrivate,
        chatRoomPrefix: assetData.chatEnablePrivate ? roomPrefix : '',
        chatConfig: assetData.chatEnabled ? {
          channel: chatChannel,
          showChat: true,
          enablePrivateRooms: !!assetData.chatEnablePrivate,
          roomPrefix: assetData.chatEnablePrivate ? roomPrefix : ''
        } : { showChat: false }
      };
    }
}
